"use client";

import React from "react";
import { cn } from "utils";
import { Icon } from "@ospweb/sdk-ui";
import { FeatureListProps } from "./types";

export const FeatureList: React.FC<FeatureListProps> = ({
  features,
  className,
}) => {
  return (
    <div
      className={cn(
        "grid [grid-template-columns:repeat(2,minmax(200px,1fr))] gap-1",
        className,
      )}
    >
      {features.map((feature, index) => (
        <div
          key={index}
          className="flex gap-1 items-center justify-start body_medium_m text-content_aura_lv1_primary"
        >
          <Icon
            name="check"
            size={16}
            className="text-content_aura_lv1_primary"
          />
          {feature.name}
        </div>
      ))}
    </div>
  );
};

FeatureList.displayName = "FeatureList";
